<template>
  <section v-if="info">
    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
      </b-nav>
      <b-nav class="ml-auto right">

        <b-nav-item
          href="#"
          @click="showPreview"
          v-b-tooltip.hover
          :title="$t('TEMPLATES.PREVIEW_DOCUMENT')"
        >
          <i class="fal fa-file-pdf" />
          <span>{{ $t('TEMPLATES.PREVIEW_DOCUMENT') }}</span>
        </b-nav-item>

        <add-document  v-if="documentVersion == null"
            :item="info"
            @update="addedDocument"
          >
            <b-nav-item href="#" v-b-tooltip.hover :title="$t('TEMPLATES.GENERATE_DOCUMENT')">
              <i class="fal fa-plus-circle" />
              <span>{{$t('TEMPLATES.GENERATE_DOCUMENT')}}</span>
            </b-nav-item>
          </add-document>
          
          <add-document-version  v-if="documentVersion != null"
                  :item="info"
                  :documentVersion="documentVersion"
                  :document="document"
                  @update="addedDocument"
                >
                  <b-nav-item href="#" v-b-tooltip.hover :title="$t('TEMPLATES.ADD_DOCUMENT_VERSION.TITLE')">
                    <i class="fal fa-plus-circle" />
                    <span>{{$t('TEMPLATES.ADD_DOCUMENT_VERSION.TITLE')}}</span>
                </b-nav-item> 
          </add-document-version>

      </b-nav>
    </b-navbar>

    <div class="container-fluid">
      <h3 class="pl-2">
        {{info.template.name }} <span v-if="documentVersion != null">{{ documentVersion.version}}</span>
        <br />
        <small>
          <router-link v-if="documentVersion != null"
          :to="{ name: 'Document', params: { dclIdentity: documentVersion.dclIdentity }}"
        >
          {{ documentVersion.dclIdentity }}
        </router-link> -  
          <router-link
          :to="{ name: 'Template', params: { dclIdentity: info.templateDocumentVersion.dclIdentity }}"
        >
          Template: {{info.template.name }} {{info.templateDocumentVersion.version }}
        </router-link>
          
        </small>
      </h3>
      <b-card no-body class="mt-2" v-if="details != null">
        <p v-for="(object,index) in texts" :key="index" class="p-2">
          {{object.value}}
        </p>
        <div v-if="chapters.length > 1">
          <b-tabs v-model="selected">
            <b-tab v-for="(object,index) in chapters" :key="index">
              <template v-slot:title><span v-if="object.id != ''">{{object.id}}.</span> {{object.title}}</template>
              <chapter-form v-if="object.type == 'chapter'" :templateId="info.template.id" :item="object"></chapter-form>
            </b-tab>
          </b-tabs> 
        </div>
        <div v-if="chapters.length == 1">
          <span v-for="(object,index) in chapters" :key="index">
             <chapter-form :templateId="info.template.id" :item="object"></chapter-form>
          </span>
        </div>
        <b-card-footer class="mt-3">
          <b-button v-show="selected != 0" @click="selected--">{{ $t('PAGINATION.PREV') }}</b-button>
          <b-button v-show="!(chapters.length == (selected+1))" class="float-right" @click="selected++">{{ $t('PAGINATION.NEXT') }}</b-button>
        </b-card-footer>
      </b-card>
      <b-card no-body class="mt-2" v-if="details == null">
        <b-card-body>
          {{$t('TEMPLATES.ERROR.COULD_NOT_PARSE_XML')}}
        </b-card-body>
      </b-card>
    </div>

    <b-modal v-model="modalPreview" hide-header size="xl" centered no-fade>
      <div class="p-4">

         <object :data="previewUrl" type="application/pdf" width="100%" height="500">
            <a href="data/test.pdf">test.pdf</a>
          </object>

      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
      </div>
    </b-modal>

  </section>
</template>
<script>
import AddDocument from "@/components/Templates/AddDocument";
import AddDocumentVersion from "@/components/Templates/AddDocumentVersion";
import ChapterForm from "@/components/Form/ChapterForm";
export default {
  components: {
    ChapterForm,
    AddDocument,
    AddDocumentVersion
  },
  props: ['documentId'],
  data() {
    return {
      info: null,
      document: null,
      documentVersion: null,
      selected: 0,
      answers: [],
      details: {},
      modalPreview: false,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showPreview()
    {
      this.modalPreview = true;
    },
    hideModals() {
      this.modalPreview = false;
    },
    getDocument: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/template/document/information", {
          documentId: this.documentId
        })
        .then(response => {
          this.info = response.data.item;
          this.document = response.data.document;
          this.documentVersion = response.data.documentVersion;
          this.details = response.data.list;
        })
        .catch(function() {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    chapterName(object) {
      return object;
    },
    addedDocument(object)
    {
        this.document = object.document;
        this.documentVersion = object.documentVersion;
    }
  },
  mounted() {
    this.getDocument();
  },
  watch: {
    documentId: function(){
       this.getDocument();
    }
  },
  computed:{
    previewUrl: function()
    {
      return process.env.VUE_APP_BACKEND + "/template/document/preview/" + this.documentId + ".pdf";
    },
    chapters: function() {
      if(this.details != null)
      {
        return this.details.filter(function(item) {
          return item.type == 'chapter';
        })
      }else{
        return null;
      }
    },
    texts: function() {
      if(this.details != null)
      {
        return this.details.filter(function(item) {
          return item.type == 'text';
        })
      }else{
        return null;
      }
    }
  }
};
</script>
